{
  "entities": {
    "warehouses": "창고 | 창고",
    "loadtypes": "화물 유형 | 화물 유형",
    "organizations": "조직 | 조직",
    "orgs": "조직 | 조직"
  }
}
